import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { userInfo } from "@/appUtils/UserInfo"

import ArgonDashboard from "./plugins/argon-dashboard";
import ElementPlus from "element-plus";
// import "element-plus/lib/theme-chalk/index.css";
import "element-plus/dist/index.css"
import ja from 'element-plus/lib/locale/lang/ja'

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

// import * as AmplifyModules from 'aws-amplify'
// import { AmplifyPlugin } from 'aws-amplify-vue'
// import { components } from 'aws-amplify-vue'

import "splitpanes/dist/splitpanes.css";
//import {store} from "./store";
import store from './store'
// import { createStore } from "vuex";

import VueLoading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

// 共通スタイル
import "@/appStyle/common.scss"

// Amplify関係のセットアップ
import Amplify from "aws-amplify";
import awsconfig from "./aws-exports.js";
import {
  applyPolyfills,
  defineCustomElements,
} from "@aws-amplify/ui-components/loader";
Amplify.configure(awsconfig);

// 多言語化対応
import { createI18n } from "vue-i18n";
const i18n = createI18n({
  locale: "ja",
  messages: {
    // 翻訳用のjson
    ja: require("./lang/ja.json"),
    en: require("./lang/en.json"),
  },
});

applyPolyfills().then(() => {
  defineCustomElements(window);
});
const options = { containerClassName: "ct-notification" };

const appInstance = createApp(App);
appInstance.config.isCustomElement = tag => tag.startsWith('amplify-');
appInstance.use(router);
appInstance.use(userInfo);
appInstance.use(ArgonDashboard);
appInstance.use(ElementPlus, {locale: ja})
//appInstance.use(ElementPlus);
appInstance.use(i18n);
appInstance.use(store);
appInstance.use(Toast, options);

appInstance.use(
  VueLoading,
  {
    container: null,
    canCancel: false,
    color: "#E4007F",
    width: 64,
    height: 64,
    backgroundColor: "#ffffff",
    opacity: 0.5,
    isFullPage: true,
    zIndex: 9999,
  },
  {}
);

appInstance.mount("#app");
